import {actions} from "../constants";

const createAction = (AllActions, action) => {
    return (AllActions.find(i => (action.value || action.action) === i.option.value) || {}).valueBuilder(action.url);
}
    

export const normalizer = (values) => {
    return {
        app_ids: values.app_ids,
        data: {
            title: values.title || '',
            content: values.content || '',
            icon: values.iconUrl || '',
            image: values.imageUrl || '',
            action: createAction(actions, values.action),
            buttons: (values.buttons || []).map(button => {
                return {
                    btn_content: button.text,
                    btn_action: createAction(actions, button),
                    btn_order: button.idx,
                }
            }),
        }
    }
}